// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AppBlock__container___2IoOu{display:flex;justify-content:center}.AppBlock__inner___3FIMp{margin:0 24px;padding:24px 16px;border:1px solid #eae9e3;border-radius:8px;text-align:center}@media (min-width:720px){.AppBlock__inner___3FIMp{padding:32px 94px}}.AppBlock__description___2E_Uh{color:inherit;font-weight:400;font-size:20px;line-height:32px;color:#6b6651}.AppBlock__app_badges___1FbOz{display:flex;justify-content:center;margin-top:24px;grid-column-gap:24px;-moz-column-gap:24px;column-gap:24px}.AppBlock__badge___obYeG{width:126px;height:38px}@media (min-width:720px){.AppBlock__badge___obYeG{width:177px;height:54px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "AppBlock__container___2IoOu",
	"inner": "AppBlock__inner___3FIMp",
	"description": "AppBlock__description___2E_Uh",
	"app_badges": "AppBlock__app_badges___1FbOz",
	"badge": "AppBlock__badge___obYeG"
};
module.exports = ___CSS_LOADER_EXPORT___;
